// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZiOtQ7","content":"iUzwbu"};